module.exports = __webpack_public_path__ + "img/ingresos.fc9267d0.svg";